export default __webpack_public_path__ + "images/ba1bcdc70bf08ae0ab6719fe64650716.svg";